// utils/request.ts

import { store } from '../store'; // Add this import at the top
import { logout } from '../store/slices/AuthSlice';
import { getUserIP } from './getUserIP';
import { navigationService } from '../services/navigationService';
const BASE_URL = process.env.REACT_APP_API_BASE_URL; // 👈 Local development URL


type RequestMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface RequestOptions<T> {
  method?: RequestMethod;
  body?: T;
  headers?: Record<string, string>;
  authorization?: boolean;
  // includeIP?: boolean;
}

export const request = async <TResponse, TBody = unknown>(
  endpoint: string,
  options: RequestOptions<TBody> = {}
): Promise<TResponse> => {
  const { method = 'GET', body, headers, authorization
    // , includeIP 
  } = options;

  const finalHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    ...headers,
  };

  if (authorization) {
    const state = store.getState();
    const token = state.auth?.token;
    if (token) {
      finalHeaders['Authorization'] = `Bearer ${token}`;
    }
  }

  // if (includeIP) {
  //   // Get user's IP address
  //   try {
  //     const userIP = await getUserIP();
  //     finalHeaders['x-user-ip'] = userIP;
  //   } catch (error) {
  //     console.warn('Could not fetch IP address:', error);
  //   }
  // }

  const config: RequestInit = {
    method,
    headers: finalHeaders,
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, config);

    if (!response.ok) {
      // Handle unauthorized access - only logout if request required authorization
      if (response.status === 401 && authorization) {
        console.log('Unauthorized access detected, logging out...');
        store.dispatch(logout());
        // Redirect to login page using navigation service
        navigationService.navigateTo('/login');
        throw new Error('Unauthorized - You have been logged out');
      }

      const errorData = await response.json();
      console.log('request err', errorData)

      const error = new Error(errorData.error || errorData.message || 'API Error');
      (error as any).errorData = errorData;
      (error as any).errors = errorData.errors || [];
      throw error;
    }

    return await response.json();
  } catch (error: any) {
    console.error('API request error:', error.message);
    throw error;
  }
};
